import { get } from './tempStorage';
export default function isLocal() {
  try {
    return get('NAVIGATION_ASSET_ENV') === 'local';
  } catch (error) {
    return false;
  }
}